module.exports = __webpack_public_path__ + "static/iphone4-sketch-pad.a3fbdc53.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketchpad/iphone4-sketch-pad.pdf
// module id = 1536
// module chunks = 119029729424783